import moment from 'moment';
import { FORMAT_START_DATE } from '../consts';

const INITIAL_STATE = {
    selectedStartDate: moment().startOf('month'),
    selectedFinalDate: moment().date(14)
};

const dateReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SET_SELECTED_START_DATE':
            return {
                ...state,
                selectedStartDate: action.payload
            };
        case 'SET_SELECTED_FINAL_DATE':
            return {
                ...state,
                selectedFinalDate: action.payload
            };
        default:
            return state;
    }
};

export default dateReducer;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/reducers/dateReducer.js